import {useContext} from "react";
import {AppLoaderContext} from "../appLoaderProvider";

function useAppLoader() {
  return useContext(AppLoaderContext);
}

export default useAppLoader;
